import { NgModule } from '@angular/core';
import { SafeUrlPipe } from './safe-url.pipe';
import { AmountFormatPipe } from './amountFormat.pipe';

@NgModule({
  declarations: [SafeUrlPipe, AmountFormatPipe],
  imports: [],
  exports: [SafeUrlPipe, AmountFormatPipe]
})
export class PipesModule { }